export enum EOccupationType {
  ANY = 0,
  CEO = 1,
  SUPERINTENDENT = 2,
  NETWORK_LEADER = 3,
  LEADER = 4,
  SPECIALIST = 5,
}
